module.exports = __webpack_public_path__ + "img/video-empty.6394d703.png";